import { Fragment } from 'react'

import type { Table as TableType } from '@/components/ui/table/types'
import { DataTableHeader } from './DataTableHeader'
import type { TableData } from './types'

interface DataTableHeadersProps<TData extends TableData> {
  table: TableType<TData>
}

export const DataTableHeaders = function DataTableHeaders<
  TData extends TableData,
>({ table }: DataTableHeadersProps<TData>) {
  const headerGroups = table.getHeaderGroups()

  return (
    <div className="flex items-center px-4 w-(--table-width)">
      {headerGroups.map((headerGroup) => (
        <Fragment key={headerGroup.id}>
          {headerGroup.headers.map((header) => (
            <DataTableHeader key={header.id} header={header} />
          ))}
        </Fragment>
      ))}
    </div>
  )
}
